import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Home01Icon,
  Image02Icon,
  Search01Icon,
} from "@hugeicons/core-free-icons";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { SearchDialog } from "@/components/dashboard/SearchDialog";

export function NavMain() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={location.pathname === "/dashboard"}
            tooltip="Home"
            className="cursor-pointer"
            onClick={() => navigate("/dashboard")}
          >
            <HugeiconsIcon icon={Home01Icon} className="size-4" />
            <span>Home</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={location.pathname === "/dashboard/assets"}
            tooltip="Assets"
            className="cursor-pointer"
            onClick={() => navigate("/dashboard/assets")}
          >
            <HugeiconsIcon icon={Image02Icon} className="size-4" />
            <span>Assets</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            tooltip="Search"
            className="cursor-pointer"
            onClick={() => setSearchOpen(true)}
          >
            <HugeiconsIcon icon={Search01Icon} className="size-4" />
            <span>Search</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
      <SearchDialog open={searchOpen} onOpenChange={setSearchOpen} />
    </SidebarGroup>
  );
}
